// DO NOT EDIT -- generated from fs/services/alexa/fieldsuggest.proto

export enum CompletionKind {
  COMPLETION_KIND_INVALID = 0,
  COMPLETION_KIND_EVENT = 1,
  COMPLETION_KIND_USER = 2
}

export interface CompletionGroup {
  field: string;
  completions: Completion[];
}

export interface Completion {
  text: string;
  score: number;
}
